import React from 'react';

function App() {
  return (
    <div>
      <h1>Hello, DevOps Engineer!</h1>
    </div>
  );
}

export default App;
